import React from "react";

import { X } from "lucide-react";

import Button from "../../Components/Button";
import CommonModal from "../../Components/Modal";
import "./style.scss";

export interface DetailField {
  label: string;
  value: string | number;
  key?: string;
}

interface AccountsDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  fields: DetailField[];
}

const AccountsDetailsModal: React.FC<AccountsDetailsModalProps> = ({
  isOpen,
  onClose,
  title,
  fields,
}) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={onClose}
      title={title}
      size="2xl"
      centered
      showHeader={false}
      className="account-details-modal"
    >
      <div className="details-modal">
        <div className="flex justify-between items-center mb-4 pb-3 border-bottom">
          <h5 className="mb-0 fw-bold">{title}</h5>
          <Button
            variant="outline-primary"
            onClick={onClose}
            className="share-modal__close-btn"
          >
            <X
              style={{
                height: 13,
                width: 13,
              }}
            />
          </Button>
        </div>

        <div className="details-section">
          {fields.map((field, index) => (
            <div key={field.key || index} className="detail-card">
              <div className="detail-label">{field.label}</div>
              <div className="detail-value">{field.value}</div>
            </div>
          ))}
        </div>

        <div className="flex justify-end mt-4 pt-3 border-top">
          <Button variant="outline-primary" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </CommonModal>
  );
};

export default AccountsDetailsModal;
